import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { mapSixFileDTOToSixFile } from "@/store/mappers/mapSixDetail";

export const uploadFile = createAppAsyncThunk(
  "sixDetail/uploadFile",
  async(
    { sixId, file }: { sixId: string; file: File },
    { extra }
  ) => {
    const dto = await extra.sixDetailService.uploadFile(sixId, file);
    return mapSixFileDTOToSixFile(dto);
  }
);
